// @flow
/* eslint-disable react/no-unused-state */
// flowlint unclear-type:off
import { Component } from 'react'

import { Logger } from 'utils/logger'

const ErrorLogger = Logger.get('ErrorBoundary')

type ErrorBoundaryProps = {
  children: React$Node,
  ...
}
type ErrorBoundaryState = {
  hasError: boolean,
  ...
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)

    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError(_error: any) {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: { componentStack: string, ... }) {
    ErrorLogger.error(error, errorInfo)
  }

  render() {
    if (this.state.hasError) return null

    return this.props.children
  }
}
